<template>
  <qx-card title="列表">
    <ChangeMoneyDialog ref="changeMoneyDialog" @sub="getData" />
    <RechargeOilDialog ref="rechargeOilDialog" @sub="getData" />
    <StatusDialog ref="statusDialog" @sub="getData" />
    <LogRightDialog ref="logRightDialog" busiCode="21000026" />
    <section slot="titleRight">
      <qx-permpisions permpisions="2000306">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="accountBO.ajax?cmd=doAccountQuery"
          :params="fullSearchData"
          bizName="司机账户列表导出"
          bizCode="exp100040"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="
                    scope.column.property === 'billId' && scope.$index !== 0
                  "
                  @click="toDriverDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section
                  v-else-if="
                    scope.column.property === 'shortName' && scope.$index !== 0
                  "
                  @click="toTenantDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section :class="{ primary: scope.$index === 0 }" v-else>
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                v-if="scope.$index !== 0"
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '2000304',
                    showCondition: true,
                    name: '资金转移',
                    event: () => showChangeMoneyDialog(scope.row),
                  },
                  {
                    permpisions: '2000305',
                    showCondition: true,
                    name: '平账',
                    event: () => balanceAccount(scope.row),
                  },
                  {
                    permpisions: '2000302',
                    showCondition: scope.row.accState === 1,
                    name: '冻结',
                    event: () => showStatusDialog(scope.row),
                  },
                  {
                    permpisions: '2000303',
                    showCondition: scope.row.accState === 0,
                    name: '解冻',
                    event: () => showStatusDialog(scope.row),
                  },
                  {
                    permpisions: '2000307',
                    showCondition: true,
                    name: '明细',
                    event: () => toDetail(scope.row),
                  },
                  {
                    permpisions: '2000308',
                    showCondition: true,
                    name: '充值油费',
                    event: () => showRechargeOilDialog(scope.row),
                  },
                  {
                    permpisions: '2000309',
                    showCondition: true,
                    name: '清零油费',
                    event: () => clearOilCost(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.userId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import RechargeOilDialog from './rechargeOilDialog';
import StatusDialog from './statusDialog';
import ChangeMoneyDialog from './changeMoneyDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  driverAccountList,
  balanceAccount,
  clearOilCost,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    RechargeOilDialog,
    StatusDialog,
    ChangeMoneyDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'billId', label: '手机号码', fixed: true },
          { prop: 'operatorName', label: '司机姓名' },
          { prop: 'shortName', label: '归属车队' },
          { prop: 'marginBalanceD', label: '未到期资金' },
          { prop: 'oilBalanceD', label: '油卡余额' },
          { prop: 'etcBalanceDD', label: 'ETC余额' },
          { prop: 'pledgeOilcardFeeD', label: '油卡押金' },
          { prop: 'receivableOverdueBalanceD', label: '应收逾期' },
          { prop: 'payableOverdueBalanceD', label: '应付逾期' },
          { prop: 'accStateName', label: '状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: driverAccountList,
    toDetail (item) {
      this.jump({
        label: '查看明细',
        url: `/manage/getPay/account/driver/detail?id=${item.userId}`,
        full: true,
      });
    },
    toDriverDetail (item) {
      this.jump({
        label: '查看司机',
        url: `/manage/archives/driver/archives/detail?id=${item.userId}`,
        full: true,
      });
    },
    toTenantDetail (item) {
      this.jump({
        label: '车队详情',
        url: `/manage/other/fleet?id=${item.tenantId}`,
        full: true,
      });
    },
    showChangeMoneyDialog (item) { // 资金转移
      this.$refs.changeMoneyDialog.show(item);
    },
    showStatusDialog (item) { // 切换状态
      this.$refs.statusDialog.show(item);
    },
    showRechargeOilDialog (item) { // 充值油费
      this.$refs.rechargeOilDialog.show(item);
    },
    async balanceAccount (item) { // 平账
      const confirmRes = await this.$confirm('单账户平账将该渠道账户的所有的金额清零，对应订单的报表也将设置成已付。已经生成了付款记录的费用（应收逾期/应付逾期）不会清除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await balanceAccount({
          userId: item.userId,
          userType: item.userType,
          zhangPingType: 1,
        });
        if (!res.failed) {
          this.$message.success('平账成功');
          this.getData();
        }
      }
    },
    async clearOilCost (item) { // 清零油费
      const confirmRes = await this.$confirm('确认将该账户的油账户金额全部清空？清空后将无法修复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await clearOilCost({
          userId: item.userId,
        });
        if (!res.failed) {
          this.$message.success('清零成功');
          this.getData();
        }
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
